<!--
 * @Author: your name
 * @Date: 2021-12-27 09:24:01
 * @LastEditTime: 2021-12-27 11:02:50
 * @LastEditors: Please set LastEditors
 * @Description:
 * @FilePath: \new-website-1123\src\views\special\gk101\page4Mobile.vue
-->
<template>
  <div class="gk101-page4-mobile pt80">
    <div class="p1-1">
      <div class="imgs-div">
        <div class="t-div t1-div">
          <ctitle titleb="智能杀虫、清虫模式"></ctitle>
          <p class="p-24">多仓并存，远程红外智能控温，烘干灭虫轻松完成。</p>
        </div>
        <img
          class="f-img data-img"
          src="https://stkjiot.com/resources/special/gk101/animate/10000.png"
          alt="上太科技"
          @load="imgLoad"
        />
        <div class="test-div test-1">
          <img
            src="https://stkjiot.com/resources/special/gk101/4.png"
            class="c-img"
            alt="上太科技"
            @load="img1Load"
          />

          <div class="i-desc desc-t desc-1">
            <span class="line-span"></span>
            <p class="line-label">测报仓</p>
          </div>

          <div class="i-desc desc-t desc-2">
            <span class="line-span"></span>
            <p class="line-label">杀虫仓</p>
          </div>
        </div>
      </div>

      <div class="content-div c1-div">
        <ul>
          <li v-for="item in arr" :key="item.title">
            <span class="t-span">{{ item.title }}</span>
            <span class="d-span">{{ item.desc }}</span>
          </li>
        </ul>
        <div class="d-div">
          <span> 注：以上信息中，监测数据为特定试验环境下抽样监测结果， </span>
          <span> 设备使用环境、使用方式及保养方式等对试验效果会有影响。 </span>
        </div>
      </div>
    </div>

    <div class="p1-2">
      <div class="t-div t2-div">
        <ctitle titleb="智能触控 12.1寸高清微电脑"></ctitle>
        <p class="p-24">内置全中文高清微电脑</p>
      </div>

      <div class="imgs-div">
        <img
          class="f-img data-img"
          src="https://stkjiot.com/resources/special/gk101/animate/10000.png"
          alt="上太科技"
          @load="imgLoad"
        />
        <div class="test-div test-2">
          <img
            class="d-img"
            src="https://stkjiot.com/resources/special/gk101/5-1.png"
            alt="上太科技"
          />
          <div class="i-desc desc-3">
            <span class="line-span"></span>
            <p class="line-label">高清微电脑</p>
          </div>
        </div>
      </div>

      <div class="content-div c2-div">
        <ul>
          <li v-for="item in arr2" :key="item.title">
            <span class="t-span">{{ item.title }}</span>
            <span class="d-span">{{ item.desc }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ctitle from "@/components/sTitle/title1";
export default {
  name: "",
  components: {
    ctitle,
  },
  data() {
    return {
      imgArr: [],
      arr: [
        {
          title: "15 min",
          desc: "到达杀虫温度（处理时间可调）",
        },
        {
          title: "85±5 ℃",
          desc: "灭虫温度",
        },
        {
          title: "≥98 %",
          desc: "虫体处理致死率",
        },
        {
          title: "≥95 %",
          desc: "虫体完整率",
        },
      ],
      arr2: [
        {
          title: "12.1寸",
          desc: "高清液晶全面屏",
        },
        {
          title: "全屏触控",
          desc: "便捷化设置各类参数",
        },
        {
          title: "模式切换",
          desc: "分时段精准控制、自动转仓和手动转仓任意切换",
        },
      ],
    };
  },
  created() {
    this.loadImgs();
  },
  methods: {
    /**
     * @description: 第一张图片加载成功
     */
    imgLoad() {
      let img = document.querySelector(".gk101-page5 .imgs-div .f-img");
      console.log(img);
    },
    /**
     * @description: 杀虫测报仓图片加载完毕
     */
    img1Load() {
      let img = document.querySelector(".gk101-page5 .test-div .c-img");
      console.log(img);
    },
    /**
     * @description: 加载图片
     */
    loadImgs() {
      for (let i = 1; i < 51; i++) {
        let name = (i < 10 ? "1000" : "100") + i;
        this.imgArr.push(
          `https://stkjiot.com/resources/special/gk101/animate/${name}.png`
        );
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.gk101-page4-mobile {
  height: auto;
  position: relative;
  overflow: hidden;
  .p1-2 {
    padding-top: 30px;
  }
  .imgs-div {
    position: relative;
    width: 100%;
    left: 0;
    & > img {
      margin-top: 20px;
      width: 100%;
      height: 100%;
      object-fit: contain;
      position: relative;
      top: 0;
      left: 20%;
      opacity: 1;
      &:first-child {
        opacity: 1;
      }
    }
    .test-div {
      position: absolute;
      top: 50%;
      left: 70%;
      transform: translateX(-50%);
      &.test-1 {
        width: 20%;
        top: 61%;
        left: 69.8%;
      }
      &.test-2 {
        width: 7.6%;
        top: 60%;
        left: 65.5%;
      }
      img {
        width: 100%;
        display: block;
        object-fit: contain;
        opacity: 1;
      }
    }
  }
  .t-div {
    position: relative;
    width: 86%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .p-24 {
      margin-top: 10px;
    }
  }
  .content-div {
    position: relative;
    width: 100%;
    opacity: 1;
    left: 0;
    padding: 0 7%;
    ul {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding-bottom: 0.73rem;
      justify-content: space-between;
      li {
        display: flex;
        flex-direction: column;
        & + li {
          margin-top: 18px;
        }
        .t-span {
          font-size: 0.73rem;
          font-family: PingFang SC;
          font-weight: 600;
          color: #1dbf73;
        }
        .d-span {
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          margin-top: 6px;
          color: rgba($color: #fff, $alpha: 0.6);
          line-height: 0.27rem;
        }
      }
    }
    .d-div {
      position: relative;
      bottom: 0.3rem;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba($color: #fff, $alpha: 0.2);
    }
  }
}

.i-desc {
  position: absolute;
  top: 50%;
  overflow: hidden;
  width: 2rem;
  &.desc-1 {
    top: 60%;
    right: 88%;
  }
  &.desc-2 {
    top: 80%;
    right: 40%;
  }
  &.desc-3 {
    right: 50%;
  }
  .line-span {
    display: block;
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgba($color: #fff, $alpha: 0.5);
  }
  p {
    margin: 0;
    white-space: nowrap;
    color: $color-active;
    position: relative;
    height: 0.29rem;
    // height: 16px;
    margin-top: 10px;
    overflow: hidden;
    font-size: 0.22rem;
    &.c-g {
      font-size: 0.29rem;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
    }
  }
}
</style>
